/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nz-card[_ngcontent-%COMP%]{border:none;padding:20px 10px;box-shadow:2px 2px 4px rgba(0,0,0,.1)}nz-skeleton[_ngcontent-%COMP%]{height:390px}[_nghost-%COMP%]     .ant-card-body{padding:0}"];
export { styles as styles };
